import { openBackUrl } from 'Util/openBackUrl'
import { TranslationContext } from 'contexts/TranslationContext'
import React, { useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import Confirmation from '~/components/base/Confirmation'
import { DropdownMenu } from '~/components/base/DropdownMenu/DropdownMenu'
import { useModalDialog } from '~/hooks'
import Avatar from '../Avatar'

const HELP_URL = 'https://www.myvideospot.com/user-guide/mystudio/'

export default function Profile() {
  const { t } = useContext(TranslationContext)
  const user = useSelector(state => state.user)

  const handleBackToAccount = useCallback(() => {
    openBackUrl(user)
  }, [ user ])

  const confirmationDialog = useModalDialog({
    onConfirm: handleBackToAccount,
  })

  const profileMenuItems = [
    {
      text: t('HEADER_BTN_BACK_TO_MY_ACC'),
      onClick: confirmationDialog.open,
    },
    {
      text: t('HEADER_BTN_HELP'),
      url: HELP_URL,
      id: 'profile-item-help',
    },
  ]
  const src = user.avatar || user.avatarUrl || user.defaultUserAvatar
  return (
    <>
      {/* <span className="header__status">Pro</span> */}
      <DropdownMenu menuItems={profileMenuItems} chevronSize={10} emitFromContent>
        <div className="header__user">
          <Avatar hideDefault={user.hideDefaultUserAvatar} src={src} />
          <span className="header__user-name">{user.displayName}</span>
        </div>
      </DropdownMenu>

      <If condition={confirmationDialog.active}>
        <Confirmation
          onCancel={confirmationDialog.cancel}
          onConfirm={confirmationDialog.confirm}
          text={t('HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR')}
        />
      </If>
    </>
  )
}
